function sanitize(context) {
  // Remove all entries with null/undefined values.
  Object.entries(context).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      delete context[key];
    }
  });
}

export default class People {
  constructor() {
    this.userKey = null;
    this.userType = 'Attendee';
    this.userEmailDomain = null;
    this.eventRegistrationId = null;
    this.name = null;
    this.email = null;
    this.$email = null;
    Object.preventExtensions(this);
  }

  setUserKey(userKey) {
    this.userKey = userKey;
    return this;
  }

  setUserEmailDomain(email) {
    if (!email) {
      return this;
    }
    this.email = email;
    this.$email = email;
    const splitEmail = email.split('@');
    this.userEmailDomain = splitEmail && splitEmail.length > 1 ? splitEmail[1] : null;
    return this;
  }

  setUserEventRegistrationId(eventRegistrationId) {
    this.eventRegistrationId = eventRegistrationId;
    return this;
  }

  setUserName(name) {
    this.name = name;
    return this;
  }

  build() {
    sanitize(this);
    return Object.freeze(this);
  }
}
